export type TGetVillagePromotionsResponse = {
  /** Список акций КП **/
  promotions: IPromotions[];
};

export interface IPromotions {
  /** Описание акции **/
  description?: string;
  /** Дата окончания акции **/
  endDate: string;
  /** ID акции **/
  id: number;
  /** Название акции **/
  name: string;
  /** Тип акции **/
  type: EType;
  /** ID КП **/
  villageId: number;
  /** Цвет заливки **/
  color?: string;
  /** Иконка акции для лейбла на выдаче **/
  labelPromoLogoUrl?: string;
  /** Иконка акции **/
  promoLogoUrl?: string;
  /** Подзаголовок **/
  subtitle?: string;
}

export enum EType {
  /** Бонус **/
  Bonus = 'bonus',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  MilitaryMortgage = 'militaryMortgage',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Скидка **/
  Sale = 'sale',
}
